export default __webpack_public_path__ + "static/media/paid_leave.42e4abda.svg";